import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { Category } from "../../../types/salon.types";

interface CategoryCardProps {
  category: Category;
  onClick: () => void;
  isActive?: boolean; // 👈 new prop
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category, onClick, isActive }) => {

  return (
    <Card
      className={`category-card ${isActive ? "active-category" : ""}`} 
      onClick={onClick}
      style={{ backgroundColor: "#f2f2f2", cursor: "pointer" }}
    >
      <CardContent style={{ padding: "8px", height: "auto" }}>
        <Typography
          variant="h6"
          component="div"
          style={{ fontSize: "14px" }}
        >
          {category.CategoryName}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default CategoryCard;
